import React, { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSolutions } from "../../services/solutionsService";
import { useServices } from "../../services/servicesService";
import { generateSlug } from "../../utils/slugUtils";

function SideMenu({ isSidebarOpen, toggleSidebar }) {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);
  const { data: solutionsData = [] } = useSolutions();
  const { data: servicesData = [] } = useServices();

  const isActive = (link) => {
    if (link === "/") {
      return location.pathname === "/";
    }
    return (
      location.pathname === link || location.pathname.startsWith(link + "/")
    );
  };

  // Check if current page is a solution page
  const isSolutionPage = location.pathname.startsWith("/solutions/");
  const isServicesPage = location.pathname.startsWith("/services/");

  const toggleMenu = (menuhome) => {
    setOpenMenu(openMenu === menuhome ? null : menuhome);
    // Reset category when closing main menu
    if (openMenu === menuhome) {
      setOpenCategory(null);
    }
  };

  const toggleCategory = (categoryIndex, e) => {
    e.preventDefault();
    setOpenCategory(openCategory === categoryIndex ? null : categoryIndex);
  };

  // Dynamically generate solutions menu from solutions API grouped by category
  const solutionsMenuItems = useMemo(() => {
    const categoryMap = {};
    solutionsData.forEach((solution) => {
      const category = solution.category || "Other";
      if (!categoryMap[category]) {
        categoryMap[category] = [];
      }
      categoryMap[category].push(solution);
    });
    return Object.keys(categoryMap).map((category, catIndex) => ({
      category,
      solutions: categoryMap[category],
      index: catIndex,
    }));
  }, [solutionsData]);

  const servicesMenuItems = useMemo(
    () =>
      servicesData.map((service, index) => ({
        label: service.name,
        link: `/services/${generateSlug(service.name)}`,
        index,
      })),
    [servicesData]
  );

  // useEffect(() => {
  //     const sidebar = document.getElementById('side-bar');
  //     const anywhereHome = document.getElementById('anywhere-home');

  //     if (isSidebarOpen) {
  //         sidebar.classList.add('show');
  //         anywhereHome.classList.add('bgshow');
  //     } else {
  //         sidebar.classList.remove('show');
  //         anywhereHome.classList.remove('bgshow');
  //     }
  // }, [isSidebarOpen]);

  return (
    <div>
      <div id="side-bar" className={`side-bar ${isSidebarOpen ? "show" : ""}`}>
        <button
          className="close-icon-menu"
          aria-label="Close Menu"
          onClick={toggleSidebar}
        >
          <i className="far fa-times"></i>
        </button>
        {/* inner menu area desktop start */}
        <div className="rts-sidebar-menu-desktop">
          <Link className="logo-1" to={"/"} onClick={toggleSidebar}>
            <img
              className="logo"
              src="/assets/images/logo/logo-12.png"
              alt="Company Logo"
            />
          </Link>

          {/* <Link className="logo-2" to={'/'} onClick={toggleSidebar}>
                        <img
                            className="logo"
                            src="/assets/images/logo/logo-12.png"
                            alt="Company Logo"
                        />
                    </Link> */}
          {/* <Link className="logo-3" to={'/'} onClick={toggleSidebar}>
                        <img
                            className="logo"
                            src="/assets/images/logo/logo-12.png"
                            alt="Company Logo"
                        />
                    </Link>
                    <Link className="logo-4" to={'/'} onClick={toggleSidebar}>
                        <img
                            className="logo"
                            src="/assets/images/logo/logo-12.png"
                            alt="Company Logo"
                        />
                    </Link> */}
          <div className="body d-none d-xl-block">
            <p className="disc">
              We provide innovative engineering solutions that ensure
              efficiency, reliability, and sustainability.
            </p>
            <div className="get-in-touch">
              {/* title */}
              <div className="h6 title">Get In Touch</div>
              {/* title End */}
              <div className="wrapper">
                {/* single */}
                {/* <div className="single">
                                    <i className="fas fa-phone-alt" />
                                    <Link href="#">+91-422-23419872</Link>
                                </div> */}
                {/* single ENd */}
                {/* single */}
                <div className="single">
                  <i className="fas fa-envelope" />
                  <Link href="mailto:enquiry@sembian.net">
                    enquiry@sembian.net
                  </Link>
                </div>
                {/* single ENd */}
                {/* single */}
                {/* <div className="single">
                                    <i className="fas fa-globe" />
                                    <Link href="#">www.webexample.com</Link>
                                </div> */}
                {/* single ENd */}
                {/* single */}
                <div className="single">
                  <i className="fas fa-map-marker-alt" />
                  <Link
                    href="https://maps.app.goo.gl/oGR2FcLUzqcZvCDc9"
                    target="_blank"
                  >
                    Coimbatore
                  </Link>
                </div>
                {/* single ENd */}
              </div>
            </div>
          </div>
          <div className="body-mobile d-block d-xl-none">
            <nav className="nav-main mainmenu-nav">
              <ul className="mainmenu metismenu" id="mobile-menu-active">
                <li
                  className={`menu-item ${
                    isActive("/about-us") ? "active" : ""
                  }`}
                >
                  <Link
                    className="menu-link"
                    to={"/about-us"}
                    onClick={toggleSidebar}
                  >
                    Company
                  </Link>
                </li>
                <li
                  className={`has-droupdown menu-item ${
                    isSolutionPage ? "active" : ""
                  }`}
                >
                  <Link
                    className="menu-link"
                    to="#"
                    onClick={() => toggleMenu(1)}
                  >
                    Solutions
                  </Link>
                  <ul className={`submenu ${openMenu === 1 ? "active" : ""}`}>
                    {solutionsMenuItems.map((item) => (
                      <li
                        key={item.index}
                        className={`mobile-menu-link has-droupdown ${
                          openCategory === item.index ? "open" : ""
                        }`}
                      >
                        <Link
                          to={"#"}
                          className={openCategory === item.index ? "open" : ""}
                          onClick={(e) => toggleCategory(item.index, e)}
                        >
                          {item.category}
                        </Link>
                        <ul
                          className={`submenu-inner ${
                            openCategory === item.index ? "active" : ""
                          }`}
                        >
                          {item.solutions.map((solution, solIndex) => (
                            <li key={solIndex}>
                              <Link
                                to={`/solutions/${generateSlug(solution.name)}`}
                                onClick={toggleSidebar}
                              >
                                {solution.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </li>
                <li
                  className={`has-droupdown menu-item ${
                    isServicesPage ? "active" : ""
                  }`}
                >
                  <Link
                    className="menu-link"
                    to="#"
                    onClick={() => toggleMenu(2)}
                  >
                    Services
                  </Link>
                  <ul className={`submenu ${openMenu === 2 ? "active" : ""}`}>
                    {servicesMenuItems.map((item) => (
                      <li key={item.index}>
                        <Link to={item.link} onClick={toggleSidebar}>
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li
                  className={`has-droupdown menu-item ${
                    isActive("/blogs") ||
                    location.pathname.startsWith("/resources")
                      ? "active"
                      : ""
                  }`}
                >
                  <Link
                    className="menu-link"
                    to="#"
                    onClick={() => toggleMenu(3)}
                  >
                    Resources
                  </Link>
                  <ul className={`submenu ${openMenu === 3 ? "active" : ""}`}>
                    <li>
                      <Link to={"/blogs"} onClick={toggleSidebar}>
                        Blogs
                      </Link>
                    </li>
                    <li>
                      <Link to={"/whitepapers"} onClick={toggleSidebar}>
                        White Papers
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={"/product-documentation"}
                        onClick={toggleSidebar}
                      >
                        Product Documentation
                      </Link>
                    </li>
                  </ul>
                </li>
                {/* <li className="menu-item">
                                    <Link className="menu-link" to={'/contactus'} onClick={toggleSidebar}>
                                        Contact
                                    </Link>
                                </li> */}
              </ul>
            </nav>
            {/* <div className="social-wrapper-two menu mobile-menu">
                            <Link href="#">
                                <i className="fab fa-facebook-f" />
                            </Link>
                            <Link href="#">
                                <i className="fab fa-twitter" />
                            </Link>
                            <Link href="#">
                                <i className="fab fa-instagram" />
                            </Link>
                            <Link href="#">
                                <i className="fab fa-whatsapp" />
                            </Link>
                        </div> */}
            <Link
              to={"/contactus"}
              className="rts-btn btn-primary ml--20 ml_sm--5 header-one-btn quote-btnmenu"
              onClick={toggleSidebar}
            >
              Contact us
            </Link>
          </div>
        </div>
        {/* inner menu area desktop End */}
      </div>
    </div>
  );
}

export default SideMenu;
